module.exports = __webpack_public_path__ + "static/img/a106.92b31000.png";